import { NavLink } from "react-router-dom";
import TelegramIcon from "@mui/icons-material/Telegram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { MAIN_TELEGRAM_URL } from "utils/telegramGroups";

import "./styles.scss";

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="footer__nav">
          <NavLink to="/" className="text">
            Über uns
          </NavLink>
          <a
            href="https://innovaforge.de/jobs/"
            className="text"
            target="_blank"
            rel="noopener noreferrer"
          >
            Jobs
          </a>
          <NavLink to="/contacts" className="text">
            Kontakte
          </NavLink>
        </div>
        <div className="footer__nav">
          <NavLink to="/network-it-rules" className="text">
            Regeln
          </NavLink>
          <NavLink to="/impressum" className="text">
            Impressum
          </NavLink>
          <NavLink to="/privacy-policy" className="text">
            Datenschutz
          </NavLink>
        </div>
        <div className="footer__rightContent">
          <div className="footer__iconsWrapper">
            <a
              className="footer__icon"
              href={MAIN_TELEGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
            >
              <TelegramIcon />
            </a>
            <a
              className="footer__icon"
              href="https://de.linkedin.com/company/innovaforge"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div>
          <a
            className="text"
            href="https://innovaforge.de"
            target="_blank"
            rel="noopener noreferrer"
          >
            Innovaforge IT Consulting & Softwareentwicklung GmbH
          </a>
          <span className="text footer__note">
            Diese Seite setzt keine Tracking- oder Marketing-Cookies.
          </span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
